import { useEffect, useState } from "react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { ProgrammesQuick } from "@/components/ProgrammesQuick";
import { WhyKiki } from "@/components/WhyKiki";
import { CampusStrip } from "@/components/CampusStrip";
import { Gallery } from "@/components/Gallery";
import { Journey } from "@/components/Journey";
import { ProgrammesDetailed } from "@/components/ProgrammesDetailed";
import { PlacementBlock } from "@/components/PlacementBlock";
import { Mentors } from "@/components/Mentors";
import { Fees } from "@/components/Fees";
import { Testimonials } from "@/components/Testimonials";
import { FAQ } from "@/components/FAQ";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { Grain } from "@/components/Grain";
import { ScrollProgress } from "@/components/ScrollProgress";
import { WhatsAppFAB } from "@/components/WhatsAppFAB";
import { SmoothScroll } from "@/components/SmoothScroll";
import { EnquiryModal } from "@/components/EnquiryModal";
import { track } from "@/lib/analytics";
import { KIKI } from "@/constants/testIds";
import { useT, useLang } from "@/lib/i18n";
import { ArrowUpRight } from "lucide-react";

export default function Landing() {
  const [enqOpen, setEnqOpen] = useState(false);
  const t = useT();
  const { lang } = useLang();

  useEffect(() => {
    track("landing_view");
  }, []);

  const openEnq = () => setEnqOpen(true);

  return (
    <SmoothScroll>
      <Grain />
      <ScrollProgress />
      <Header onOpenEnquiry={openEnq} />
      <main>
        <Hero onEnquire={openEnq} />
        <ProgrammesQuick onEnquire={openEnq} />
        <WhyKiki />
        <CampusStrip />
        <Journey onEnquire={openEnq} />
        <ProgrammesDetailed onEnquire={openEnq} />
        <PlacementBlock onEnquire={openEnq} />
        <Mentors onEnquire={openEnq} />
        <Gallery />
        <Testimonials />
        <Fees onEnquire={openEnq} />
        <FAQ />
        <Contact onEnquire={openEnq} />
      </main>
      <Footer />

      <WhatsAppFAB />

      <button
        onClick={openEnq}
        data-testid={KIKI.ctaEnquireSticky}
        className={`md:hidden fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 px-5 py-3 bg-[#FFCC00] text-black rounded-full text-sm font-semibold shadow-lg ${lang === "hi" ? "font-hindi" : ""}`}
      >
        {t("stickyCta")} <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
      </button>

      <EnquiryModal open={enqOpen} onClose={() => setEnqOpen(false)} />
    </SmoothScroll>
  );
}
